<template>

  <div style="width: 100%; height: 100%; background-color: white;">
    <div style="width: 100%; height: 50px; line-height: 50px; font-size: 20px;">
      {{merchant.title}}
      <button class="btn btn-dark" style="float: right; font-size: 20px; margin-right:20px;margin-top:5px;" @click="closeView">Close</button>
    </div>
    <div style="width: 100%; height: calc(100% - 50px); display: flex;">
      <div style="width: 150px; height: 100%; overflow-y: scroll;">
        <ul class="list-group">
          <li class="list-group-item" v-for="category in categories" v-bind:class="{'selected-category': category.id === categoryId}" @click="onCategorySelected(category.id)">
            {{category.title}}
          </li>
        </ul>
      </div>
      <div style="width: calc(100% - 150px); height: 100%;">
        <div style="width: 100%; height: 50px; line-height: 50px; display: flex;">
          <div style="width: 50%; height: 50px; line-height: 50px; text-align: left; font-weight: bold; font-size: 20px; padding-left: 20px;">
            {{getCurrentCategoryTitle()}}
          </div>
          <div style="width: 50%; height: 50px; text-align: right; padding-right: 20px;">
            <template v-if="categoryId > 0 && products !== null && products.length > 0">
              <button class="btn btn-danger" style="margin-right: 30px;" @click="toggleAll(false)">Disable All</button>
              <button class="btn btn-primary" @click="toggleAll(true)">Enable All</button>
            </template>
          </div>
        </div>
        <div style="width: 100%; height: calc(100% - 50px); overflow-y: scroll;">
          <table class="table" v-if="products !== null">
            <thead>
            <tr class="stick-top-row">
              <th class="text-left">Code</th>
              <th class="text-left">상품명</th>
              <th class="text-left">Vendor</th>
              <th class="text-left">단위</th>
              <!--            <th>원가</th>-->
              <!--            <th>마진</th>-->
              <!--            <th>판매가</th>-->
              <!--            <th>VAT</th>-->
              <th>판매</th>

              <!--            <th>Meta</th>-->
              <th>매장 판매</th>

            </tr>
            </thead>
            <tbody v-for="item in products">
            <tr>
              <td>{{item.code}}</td>
              <td class="text-left">{{item.title}}<span v-if="item.deleted === true">&nbsp;&nbsp; <strong>DELETED</strong></span></td>
              <td class="text-left">
                <div v-if="item.vendors.length > 0"></div>
                <span v-for="(v, i) in item.vendors"><span v-if="i>0">,</span>{{v.title}}</span>
              </td>
              <td class="text-left">{{item.unit}}</td>
              <!--            <td>{{(item.sourcePrice/100.0).toFixed(2)}}</td>-->
              <!--            <td><span v-if="item.marginRate > 0">{{(item.marginRate/100.0).toFixed(2)}}%</span><span v-else-if="item.marginAmount > 0">£{{(item.marginAmount/100.0).toFixed(2)}}</span></td>-->
              <!--            <td>{{(item.price/100.0).toFixed(2)}}</td>-->
              <!--            <td>{{(item.taxRate/100).toFixed(2)}}%</td>-->
              <td>
                <i v-if="item.available==true" class="fas fa-check" style="color: green;"></i>
                <i v-else class="fas fa-times" style="color: red;"></i>
              </td>
              <!--            <td>-->
              <!--              <span v-if="item.merchantMeta === null">-->
              <!--                N-->
              <!--              </span>-->
              <!--              <span v-else>Y</span>-->
              <!--            </td>-->
              <td @click="toggleAvailability(item)">
                <template v-if="item.merchantMeta !== null">
                  <i v-if="item.merchantMeta.available==true" class="fas fa-check" style="color: green;"></i>
                  <i v-else class="fas fa-times" style="color: red;"></i>
                </template>
                <template v-else>
                  <i class="fas fa-check" style="color: green;"></i>
                </template>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {getCategories, getMerchantProducts, updateProductMetaItem, updateProductMetaItems} from "../api/product";
import {showDialog} from "../api/utils";

export default {
  name: "MerchantProductView",
  props: {
    merchant:{
      type:Object,
      default:function(){return null;}
    },
    onClose:{
      type:Function,
      default:null,
    }
  },
  data() {
    return {
      categories:[],
      categoryId:0,
      products:[],
    }
  },
  created() {
  },
  mounted() {
    this.initialise();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    initialise: function() {
      this.getCategoryList();
    },
    getCurrentCategoryTitle: function() {
      if(this.$data.categories === null || this.$data.categories.length == 0) {
        return '';
      }
      if(this.$data.categoryId > 0) {
        for(let i = 0 ; i < this.$data.categories.length ; i++) {
          if(this.$data.categories[i].id === this.$data.categoryId) {
            return this.$data.categories[i].title;
          }
        }
      }
      return '';
    },
    getCategoryList: function() {
      this.$data.categories = [];
      let self = this;
      getCategories()
      .then(function(data) {
        if(data.success === true) {
          self.$data.categories = data.item;
        } else {
          showDialog(data.message);
        }
      })
      .catch(function(err) {
        let msg = err;
        if(err.response !== undefined) {
          msg += ' (' + err.response + ')';
        }
        showDialog(msg, "ERROR to get categories");
      })
    },
    onCategorySelected: function(id) {
      if(this.$data.categoryId === id) {
        return;
      }

      this.$data.categoryId = id;
      this.$data.products = [];
      let query = 'merchantId='+this.merchant.id + '&categoryId=' + this.$data.categoryId + "&type=";
      let self = this;
      getMerchantProducts(query)
      .then(function(data) {
        if(data.success === true) {
          self.$data.products = data.item;
        } else {
          showDialog(data.message);
        }
      })
      .catch(function(err) {
        let msg = err;
        if(err.response !== undefined) {
          msg += ' (' + err.response + ')';
        }
        showDialog(msg, "ERROR to get categories");
      })
    },
    toggleAvailability: function(product) {
      if(product.merchantMeta === null) {
        let meta = {
          id:0,
          productId:product.id,
          merchantId:this.merchant.id,
          available: false,
          marginRate:0,
          marginAmount:0,
          price:0,
        }
        product.merchantMeta = meta;
      } else {
        product.merchantMeta.available = !product.merchantMeta.available;
      }

      updateProductMetaItem(product.merchantMeta)
      .then(function(data) {
        if(data.success === true) {
          product.merchantMeta = data.item;
        } else {
          showDialog(data.message);
        }
      })
      .catch(function(err) {
        let msg = err;
        if(err.response !== undefined) {
          msg += ' (' + err.response + ')';
        }
        showDialog(msg, "ERROR to get categories");
      })


    },
    toggleAll: function(available) {
      let title = available===true?'Enable':'Disable';
      title += " all items";

      let key = available===true?'enable':'disable';
      let message = "Process to " + key;
      message += " all items for " + this.merchant.title + "?";
      let self = this;
      this.$modal.show('dialog',{
        title: title,
        text: message,
        buttons:[
          {
            title:"Cancel",
            handler: () => {
              self.$modal.hide('dialog');

            }
          },
          {
            title:title,
            handler: () => {

              self.$modal.hide('dialog');
              self.toggleAllConfirmed(available);

            }
          }
        ]
      })
    },
    toggleAllConfirmed: function(available) {

      let list = [];
      for(let i = 0 ; i < this.$data.products.length ; i++) {
        if(this.$data.products[i].merchantMeta === null) {
          let meta = {
            id:0,
            productId:this.$data.products[i].id,
            merchantId:this.merchant.id,
            available: available,
            marginRate:0,
            marginAmount:0,
            price:0,
          }

          list.push(meta);
        } else {
          this.$data.products[i].merchantMeta.available = available;
          list.push(this.$data.products[i].merchantMeta);
        }
      }

      if(list.length === 0) {
        return;
      }
      let self = this;
      updateProductMetaItems(list)
      .then(function(data){
        if(data.success === true) {
          for(let i = 0 ; i < data.item.length ; i++) {
            for(let j = 0 ; j < self.$data.products.length ; j++) {
              if(self.$data.products[j].id === data.item[i].productId) {
                self.$data.products[j].merchantMeta = data.item[i];
                break;
              }
            }
          }
        } else {
          showDialog(data.message);
        }
      })
      .catch(function(err) {
        let msg = err;
        if(err.response !== undefined) {
          msg += ' (' + err.response + ')';
        }
        showDialog(msg, "ERROR to get categories");
      })
    },
    closeView: function() {
      if(this.onClose !== null) {
        this.onClose();
      }
    }
  }
}
</script>

<style scoped>
.selected-category {
  background-color: blue;
  color:white;
}
.stick-top-row > th {
  position: sticky;
  top:0;
  background-color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/MerchantProductView.vue